import { ExportItem } from '@aibees/elephant/hooks/types';
import type { AdvanceTableActionProps } from '@aibees/shared/features';

export interface ExportTableActionProps
  extends AdvanceTableActionProps<ExportItem> {
  className?: string;
}

export enum ExportTableActionType {
  edit,
  view,
  copyID,
  retry,
  viewCampaign,
  downloadCSV,
}
